import "../styles/Gallery.css"
import Gallery1 from "../assets/images/Gallery1.jpeg"
import Gallery2 from "../assets/images/Gallery2.jpeg"
import Gallery3 from "../assets/images/Gallery3.jpeg"
import Gallery4 from "../assets/images/Gallery4.jpeg"
import Gallery5 from "../assets/images/Gallery5.jpeg"
import Gallery6 from "../assets/images/Gallery6.jpeg"

export default function Gallery() {
  const galleryImages = [
    {
      id: 1,
      alt: "Gallery1",
      image: `${Gallery1}`,
    },
    {
      id: 2,
      alt: "Gallery2",
      image: `${Gallery2}`,
    },
    {
      id: 3,
      alt: "Gallery3",
      image: `${Gallery3}`,
    },
    {
      id: 4,
      alt: "Gallery4",
      image: `${Gallery4}`,
    },
    {
      id: 5,
      alt: "Gallery5",
      image: `${Gallery5}`,
    },
    {
      id: 6,
      alt: "Gallery6",
      image: `${Gallery6}`,
    },
  ]

  return (
    <section id="gallery" className="gallery">
      <h3 className="section-label">GALLERY</h3>
      <h2 className="section-title">Premier Property Collection</h2>

      <div className="gallery-grid">
        {galleryImages.map((image) => (
          <div key={image.id} className="gallery-item">
            <img src={image.image || "/placeholder.svg"} alt={image.alt} />
          </div>
        ))}
      </div>
    </section>
  )
}
